<template>
  <div class="asc__showPage">
    <div class="asc__showPage-times">
      <i class="fas fa-times-circle" @click="closeQuick()" />
    </div>
    <div class="asc__showPage-container">
      <b-row>
        <b-col cols="12">
          <header>
            <Breadcrumb :title="rowData.Description1" />
            <div class="clearfix"></div>
          </header>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <section>
            <span><i class="fas fa-code" />  <b>{{$t('get.asset.code')}}:</b> {{rowData.Code && rowData.Code}}</span>
            <span><i class="fas fa-code" />  <b>{{$t('get.asset.description1')}}:</b> {{rowData.Description1}}</span>
            <!-- <span><i class="fas fa-check" />  <b>{{$t('get.status')}}:</b> {{(rowData.StatusId) ? $t('insert.active') : $t('insert.passive')}}</span> -->
          </section>
        </b-col>
      </b-row>
      <b-tabs>
        <b-tab :title="$t('get.asset.general')" active>
          <b-row class="p-4">
            <b-card class="col-md-6 col-12 asc__showPage-card">
              <div v-html="getFormatDataByType(rowData.Producer, 'object', 'get.asset.producer')"></div>
              <div v-html="getFormatDataByType(rowData.Brand, 'object', 'get.asset.brand')"></div>
              <div v-html="getFormatDataByType(rowData.Model, 'object', 'get.asset.model')"></div>
              <div v-html="getFormatDataByType(rowData.AssetType, 'object', 'get.asset.assetType')"></div>
              <div v-html="getFormatDataByType(rowData.FurnitureExpense, 'text', 'Mobilya Masrafı')"></div>
            </b-card>
            <b-card class="col-md-6 col-12 asc__showPage-card">
              <div v-html="getFormatDataByType(rowData.Type, 'object', 'get.asset.type')"></div>
              <div v-html="getFormatDataByType(rowData.AssetClass, 'object', 'get.asset.assetClass')"></div>
              <div v-html="getFormatDataByType(rowData.TrackType, 'object', 'get.asset.trackType')"></div>
              <div v-html="getFormatDataByType(rowData.Barcode, 'text', 'get.asset.barcode')"></div>
              <div v-html="getFormatDataByType(rowData.ShelfQuantity, 'text', 'Önyüz Sayısı')"></div>
            </b-card>
          </b-row>
        </b-tab>
        <b-tab  :title="$t('get.asset.properties')" v-if="rowData.AssetPropertyValues && rowData.AssetPropertyValues.length > 0">
          <b-row>
            <b-col cols="12" md="12">
              <b-card class="m-3 asc__showPage-card">
                <b-table responsive :items="rowData.AssetPropertyValues" :fields="assetPropertyValueFields">
                  <template #head()="data">
                    {{$t(data.label)}}
                  </template>
                  <template #cell(Description1)="{item}">
                    {{item.Property ? item.Property.Label : item.Description1}}
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import mixin from '../../mixins/index'
export default {
  mixins: [mixin],
  props: ['dataKey'],
  data () {
    return {
      assetPropertyValueFields: [
        {
          key: 'Description1',
          label: 'get.asset.propertyName'
        },
        {
          key: 'Value',
          label: 'get.asset.propertyValue'
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    ...mapState(['rowData', 'style'])
  },
  methods: {
    closeQuick () {
      this.$router.push({name: this.$route.meta.base})
    },
    getData () {
      this.$store.dispatch('getData', {...this.query, api: 'VisionNextAsset/api/Asset', record: this.$route.params.url})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Asset/get.vue